import { Flex } from '@atlaskit/primitives';

import SiteSelector from './SiteSelector/SiteSelector';
import type { FunctionComponent } from 'react';
import Headline from './Headline';
import PermissionsBullets from './PermissionsBullets';
import SiteBypassBanner from '../shared/agent-consent/SiteBypassBanner/SiteBypassBanner';

const Rovo: FunctionComponent = () => {
  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Flex alignItems="center" direction="column" gap="space.400">
        <Headline />
      </Flex>
      <SiteBypassBanner />
      <SiteSelector />
      <PermissionsBullets />
    </Flex>
  );
};

export default Rovo;
